import { URL } from './endpoints'
import { submitToApi } from 'awsApi'
import { createAssessmentTemplate } from 'assets/database/assessment'
import { createAssessmentList, createOnboardingSteps } from 'assets/database/onboarding'

export const ACTIONS = {
    POST_ASSESSMENT: {
        START: 'POST_ASSESSMENT START',
        SUCCESS: 'POST_ASSESSMENT SUCCESS',
        FAILURE: 'POST_ASSESSMENT FAILURE',
    },
    POST_ASSESSMENT_UPDATE: {
        START: 'POST_ASSESSMENT_UPDATE START',
        SUCCESS: 'POST_ASSESSMENT_UPDATE SUCCESS',
        FAILURE: 'POST_ASSESSMENT_UPDATE FAILURE',
    },
    GET_ASSESSMENT: {
        START: 'GET_ASSESSMENT START',
        SUCCESS: 'GET_ASSESSMENT SUCCESS',
        FAILURE: 'GET_ASSESSMENT FAILURE',
    },
    GET_ASSESSMENT_UPDATES: {
        START: 'GET_ASSESSMENT_UPDATES START',
        SUCCESS: 'GET_ASSESSMENT_UPDATES SUCCESS',
        FAILURE: 'GET_ASSESSMENT_UPDATES FAILURE',
    },
    SET_ANSWER: 'SET_ANSWER',
    SET_ANSWER_OPEN_TEXT: 'SET_ANSWER_OPEN_TEXT',
    SET_NEXT_QUESTION: 'SET_NEXT_QUESTION',
    SET_ONBOARDING_STEP: 'SET_ONBOARDING_STEP',
    CHANGE_ONBOARDING_STEP_STATE: 'CHANGE_ONBOARDING_STEP_STATE',
    GET_ASSESSMENT_TEMPLATE: 'GET_ASSESSMENT_TEMPLATE',
    GET_ASSESSMENT_LIST: 'GET_ASSESSMENT_LIST',
    SET_ANSWER_FORMAT: 'SET_ANSWER_FORMAT',
    SET_ONBOARDING_ANSWERS: 'SET_ONBOARDING_ANSWERS',
    GET_ONBOARDING_TEMPLATE: 'GET_ONBOARDING_TEMPLATE',
}

export const getAssessmentTemplate =
    (pilotTag = '', pillarsGoals) =>
    dispatch =>
        dispatch({ type: ACTIONS.GET_ASSESSMENT_TEMPLATE, data: createAssessmentTemplate({ pilotTag, pillarsGoals }) })

export const getOnboardingSteps = () => dispatch => {
    dispatch({ type: ACTIONS.GET_ONBOARDING_TEMPLATE, data: createOnboardingSteps() })
}

export const getAssessmentList = pilotTag => dispatch => {
    dispatch({ type: ACTIONS.GET_ASSESSMENT_LIST, data: createAssessmentList(pilotTag) })
}

export const getAssessment = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_ASSESSMENT.START })
    try {
        const { payload } = await submitToApi({
            path: URL.WELLBEING_ASSESSMENTS.V3_WELLBEING_ASSESSMENTS_WA_UPDATES_USER_RETRIEVE,
            url: URL.WELLBEING_ASSESSMENTS.BASE,
        })
        dispatch({ type: ACTIONS.GET_ASSESSMENT.SUCCESS, data: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_ASSESSMENT.FAILURE, error })
    }
}

export const getAssessmentUpdates = () => async dispatch => {
    dispatch({ type: ACTIONS.GET_ASSESSMENT_UPDATES.START })
    try {
        const { payload } = await submitToApi({
            path: URL.WELLBEING_ASSESSMENTS.V3_WELLBEING_ASSESSMENTS_WA_UPDATES_USER_RETRIEVE,
            query: 'userId',
            url: URL.WELLBEING_ASSESSMENTS.BASE,
        })
        dispatch({ type: ACTIONS.GET_ASSESSMENT_UPDATES.SUCCESS, data: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_ASSESSMENT_UPDATES.FAILURE, error })
    }
}

// action that calls the API and posts the assessment from assessmentStore.AppState.answers
export const postAssessment =
    (body, successCallback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.POST_ASSESSMENT.START })
        try {
            await submitToApi({
                body,
                method: 'POST',
                path: URL.WELLBEING_ASSESSMENTS.V3_WELLBEING_ASSESSMENTS_USER_CREATE,
                url: URL.WELLBEING_ASSESSMENTS.BASE,
            })
            dispatch({ type: ACTIONS.POST_ASSESSMENT.SUCCESS })
            successCallback()
        } catch (error) {
            dispatch({ type: ACTIONS.POST_ASSESSMENT.FAILURE, error })
        }
    }

// action that calls the API and posts the assessment from assessmentStore.AppState.answers
export const postAssessmentUpdate =
    (body, successCallback = () => {}, errorCallback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.POST_ASSESSMENT_UPDATE.START })
        try {
            await submitToApi({
                body,
                method: 'POST',
                path: URL.WELLBEING_ASSESSMENTS.V3_WELLBEING_ASSESSMENTS_WA_UPDATES_USER_CREATE,
                url: URL.WELLBEING_ASSESSMENTS.BASE,
            })
            dispatch({ type: ACTIONS.POST_ASSESSMENT_UPDATE.SUCCESS })
            successCallback()
        } catch (error) {
            dispatch({ type: ACTIONS.POST_ASSESSMENT_UPDATE.FAILURE, error })
            errorCallback()
        }
    }

export const setNewAnswerFormat = () => dispatch => dispatch({ type: ACTIONS.SET_ANSWER_FORMAT })

export const setAnswer = answer => dispatch => dispatch({ type: ACTIONS.SET_ANSWER, answer })

export const setAnswerOpenText = text => dispatch => dispatch({ type: ACTIONS.SET_ANSWER_OPEN_TEXT, data: text })

export const setNextQuestion = val => dispatch => dispatch({ type: ACTIONS.SET_NEXT_QUESTION, data: val })

export const setOnboardingAnswers = (data, change) => dispatch =>
    dispatch({
        type: ACTIONS.SET_ONBOARDING_ANSWERS,
        data,
        change,
    })

export const setOnboardingStep = data => dispatch => dispatch({ type: ACTIONS.SET_ONBOARDING_STEP, data })

export const activateOnboardingStep = data => dispatch => dispatch({ type: ACTIONS.CHANGE_ONBOARDING_STEP_STATE, data })
